import type { TestimonialsCollectionState } from './testimonials.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';
import { TESTIMONIALS_COLLECTION_FEATURE_KEY, testimonialsAdapter } from './testimonials.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollectionQuery, selectCollectionQueryStatuses } = testimonialsAdapter.getSelectors();

export const selectTestimonialsState = createSelector(
    collectionsState,
    (state: CollectionsState): TestimonialsCollectionState => state[TESTIMONIALS_COLLECTION_FEATURE_KEY]
);

export const selectTestimonials = (id: string) => createSelector(selectTestimonialsState, selectCollectionQuery(id));

export const selectTestimonialsStatuses = (id: string) =>
    createSelector(selectTestimonialsState, selectCollectionQueryStatuses(id));
